import './MyTopPick.scss';
import my_top_pick1 from './img/MyTopPick1.png';
import my_top_pick2 from './img/MyTopPick2.png';
import move_right from './img/move_right.png';
import { SectionHeading } from '../Typography';


export default function MyTopPick(){
    return <>
        <div className='container'>
            <div className='top_cusines home-pick-strip'>
              <SectionHeading>MY TOP PICKS</SectionHeading>
              <div className='home-pick-strip__row'>
                <div className='home-pick-strip__cell'>
                    <img src={my_top_pick1} alt="" className='home-pick-strip__media my_top_pick1' />
                </div>
                <div className='home-pick-strip__cell'>
                    <img src={my_top_pick2} alt="" className='home-pick-strip__media my_top_pick2' />
                </div>
                <div className='home-pick-strip__cell'>
                    <img src={my_top_pick1} alt="" className='home-pick-strip__media my_top_pick1' />
                </div>
                <div className='home-pick-strip__arrow move_right_div'>
                    <img src={move_right} alt="" className='move_right' />
                </div>
              </div>
            </div>
        </div>
    </>
}